export default __webpack_public_path__ + "static/DianaTurbay-993ed8d1e8ca5301d9b4fe764029814f.jpg";